import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { MenuItemType } from 'sections/PromoSection/pages/PromoPage/types'
import { TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { scrollToId } from 'utils/helpers/scrollToId'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { EventType } from 'types/types'

import MinusIcon from 'assets/icons/minus.svg?react'
import PlusIcon from 'assets/icons/plus.svg?react'
import s from './FooterLinksWrapper.module.scss'

interface IFooterLinksWrapperProps {
  title: string
  links: MenuItemType[]
  wide?: boolean
}

export const FooterLinksWrapper: FC<IFooterLinksWrapperProps> = observer(({ title, links, wide }) => {
  const [collapsed, setCollapsed] = useState<boolean>(false)
  const navigate = useNavigate()

  const { isSDesktop } = useResize()

  const toggle = () => {
    setCollapsed((prev) => !prev)
  }

  const handleSelectMenuItem = (e: React.MouseEvent, link: MenuItemType) => {
    e.preventDefault()
    sendEvent(EventType.FooterT, { name: link.label })

    if (link.type === 'anchor') {
      scrollToId(link.path)
    } else if (link.type === 'link') {
      window.open(link.path, '_blank')
    } else {
      navigate(link.path, { replace: false })
    }
  }

  const showToggler = (!isSDesktop && !collapsed) || collapsed

  return (
    <div className={`${s.footerLinks} ${wide ? s.wide : ''}`}>
      <div onClick={toggle} className={s.categoryTitle}>
        <TextPromo className={s.title} fontFamily="ASLHauss" size="s20" weight="w500" color="white">
          {title}
        </TextPromo>
        {isSDesktop && (
          <TextPromo size="s40" weight="w550" color="white">
            {!showToggler ? <PlusIcon /> : <MinusIcon />}
          </TextPromo>
        )}
      </div>

      {showToggler &&
        links.map((link) => (
          <Href key={link.id} className={s.footerLink} href={link.path} onClick={(e) => handleSelectMenuItem(e, link)}>
            {link.label}
          </Href>
        ))}
    </div>
  )
})
